import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src1046095046/src/app/[locale]/(site)/_components/LandingHomePage.tsx");
